module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_7016.0c0dbfdb.png";